import React from "react";
import "./ChooseMinemi.css";

const ChooseMinemi = () => {
  return (
    <>
      <div id="choose-minemi-loan-eligibility" className="bg-transparent">
        <div id="list-of-documents-container">
          <div id="documents-content" className="bg-transparent">
            <div className="documents-content-container bg-transparent">
              <div className="content-box w-100 bg-transparent ">
                {" "}
                <div className="documents-text-box bg-transparent">
                  <div className="bg-transparent">
                    <div id="choose-minemi-head-box" className="bg-transparent">
                      <div className="choose-minemi-heading bg-transparent">
                        <h4 id="documents-heading" className="bg-transparent">
                          Why Choose MinEmi for Loan Consolidation?
                        </h4>
                      </div>
                    </div>

                    <div className="text-box bg-transparent">
                      <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                        <p className="symbol-para bg-transparent">#</p>
                        <p className="text-para bg-transparent">
                          Get customized consolidation plans to reduce your EMI
                          and save money
                        </p>
                      </div>
                      <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                        <p className="symbol-para bg-transparent">#</p>
                        <p className="text-para bg-transparent">
                          Access the lowest interest rates available in the
                          market.
                        </p>
                      </div>
                      <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                        <p className="symbol-para bg-transparent">#</p>
                        <p className="text-para bg-transparent">
                          Streamline your financial management with a single
                          EMI.
                        </p>
                      </div>
                      <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                        <p className="symbol-para bg-transparent">#</p>
                        <p className="text-para bg-transparent">
                          We work with top lenders to ensure maximum savings for
                          you.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="documents-image-box d-none d-md-block">
                  <div>
                    <img
                      className="documents-image"
                      src={Image}
                      alt="docuents-image"
                    />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChooseMinemi;
